var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.8841 19.5944C22.8841 19.9694 22.8008 20.3548 22.6237 20.7298C22.4466 21.1048 22.2174 21.459 21.9154 21.7923C21.4049 22.3548 20.8424 22.7611 20.207 23.0215C19.582 23.2819 18.9049 23.4173 18.1758 23.4173C17.1133 23.4173 15.9779 23.1673 14.7799 22.6569C13.582 22.1465 12.3841 21.459 11.1966 20.5944C9.9987 19.7194 8.86328 18.7507 7.77995 17.6777C6.70703 16.5944 5.73828 15.459 4.8737 14.2715C4.01953 13.084 3.33203 11.8965 2.83203 10.7194C2.33203 9.5319 2.08203 8.39648 2.08203 7.31315C2.08203 6.60482 2.20703 5.92773 2.45703 5.30273C2.70703 4.66732 3.10286 4.08398 3.65495 3.56315C4.32161 2.9069 5.05078 2.58398 5.82161 2.58398C6.11328 2.58398 6.40495 2.64648 6.66536 2.77148C6.9362 2.89648 7.17578 3.08398 7.36328 3.35482L9.77995 6.76107C9.96745 7.02148 10.1029 7.26107 10.1966 7.49023C10.2904 7.70898 10.3424 7.92773 10.3424 8.12565C10.3424 8.37565 10.2695 8.62565 10.1237 8.86523C9.98828 9.10482 9.79036 9.35482 9.54036 9.60482L8.7487 10.4277C8.63411 10.5423 8.58203 10.6777 8.58203 10.8444C8.58203 10.9277 8.59245 11.0007 8.61328 11.084C8.64453 11.1673 8.67578 11.2298 8.69661 11.2923C8.88411 11.6361 9.20703 12.084 9.66536 12.6257C10.1341 13.1673 10.6341 13.7194 11.1758 14.2715C11.7383 14.8236 12.2799 15.334 12.832 15.8027C13.3737 16.2611 13.8216 16.5736 14.1758 16.7611C14.2279 16.7819 14.2904 16.8132 14.3633 16.8444C14.4466 16.8757 14.5299 16.8861 14.6237 16.8861C14.8008 16.8861 14.9362 16.8236 15.0508 16.709L15.8424 15.9277C16.1029 15.6673 16.3529 15.4694 16.5924 15.3444C16.832 15.1986 17.0716 15.1257 17.332 15.1257C17.5299 15.1257 17.7383 15.1673 17.9674 15.2611C18.1966 15.3548 18.4362 15.4902 18.6966 15.6673L22.1445 18.1152C22.4154 18.3027 22.6029 18.5215 22.7174 18.7819C22.8216 19.0423 22.8841 19.3027 22.8841 19.5944Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.2708 9.87435C19.2708 9.24935 18.7812 8.29102 18.0521 7.50977C17.3854 6.79102 16.5 6.22852 15.625 6.22852",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.9167 9.87565C22.9167 5.8444 19.6562 2.58398 15.625 2.58398",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconProduct);
export default __webpack_public_path__ + "static/media/phone_icon-product.520a97d3f548196c6d809332b835def4.svg";
export { ForwardRef as ReactComponent };